import ViewBase from "../../../../framework/core/mvvm/view_base";
import { JdHelp } from "./help/jd_help";
import { JdTableData } from "./data/jd_table_data";
import GameUtil from "../../../../utility/game_util";
import TexasSound from "../../../texasholdem/module/texas_sound";
import Utility from "../../../../utility/utility";
import AppData from "../../../public/const/app_data";
import TableBaseView from "../../../table/module/table_base/table_base_view";

const {ccclass, property} = cc._decorator;

@ccclass
export class JdPokerView extends TableBaseView{

    @property(cc.Node)
    gameRoot:cc.Node = null;

    @property(cc.Node)
    talePrefab:cc.Node = null;

    @property([cc.Node])
    operatorNode:cc.Node[] = [];

    @property(cc.Node)
    allInNode:cc.Node = null;

    @property(cc.Node)
    leftOperator:cc.Node = null;

    @property(cc.Node)
    isInGame:cc.Node = null;

    @property(cc.Node)
    noGame:cc.Node = null;

    @property(cc.Label)
    inGameOperator:cc.Label = null;

    @property(cc.Node)
    allInBtn:cc.Node = null;

    @property([cc.Node])
    autoBtn:cc.Node[] = [];

    @property(cc.Node)
    clickEff:cc.Node = null;

    @property([cc.Node])
    allBetBtn:cc.Node[] = [];

    @property(cc.Node)
    maskEvent:cc.Node = null;

    @property(cc.Node)
    slider:cc.Node = null;

    @property(cc.Label)
    sliderLab:cc.Label = null;

    @property(cc.Node)
    betPrefab:cc.Node = null;

    @property(cc.Label)
    roundNumb:cc.Label = null;

    @property(cc.Node)
    call:cc.Node = null;//跟牌node

    @property(cc.Label)
    callLab:cc.Label = null;

    @property(cc.Label)
    graylab:cc.Label = null;

    @property(cc.Node)
    checkNode:cc.Node = null;

    @property(cc.Node)
    autoCall:cc.Node = null;

    @property(cc.Label)
    autoCheckNumb:cc.Label = null;

    @property(cc.Node)
    autoCheckNode:cc.Node = null;

    @property(cc.Node)
    maskRect:cc.Node  = null;

    @property(cc.Node)
    allInPng:cc.Node = null;

    sliderProgress:cc.Slider = null;

    @property(cc.Node)
    test:cc.Node = null;

    @property([cc.Font])
    fonts:cc.Font[] = [];//0正常1 置灰

    onLoad(){
        this.allInNode.active = false;
        this.isInGame.active = false;
        this.noGame.active = false;
        this.sliderProgress = this.slider.getComponent(cc.Slider);
        let progressbar = this.slider.getComponent(cc.ProgressBar);
    
        if(this.sliderProgress == null || progressbar == null){
            return;
        }
        progressbar.progress = this.sliderProgress.progress;

        this.sliderProgress.node.on('slide', function(event){
            progressbar.progress = this.sliderProgress.progress;
        }, this);

        this.test.active = AppData.testMode;
    }

    oldbet = 0;
    updateSliderUI(progress:number,v:number,isPlaySound:boolean = true){
        if (progress >= 1) {
            progress = 1;
        }
        this.sliderProgress.progress = progress;
        this.sliderLab.node.active = (progress < 1);
        this.allInPng.active = progress >= 1;
        this.updateMaskSize(progress);
        if (progress >= 1) {//all-in
            
        }else{
            let str = GameUtil.currencyFormatting(v);
            str = str.replace('.','a');
            this.sliderLab.string = str;
            if (isPlaySound && this.oldbet != v) {
                this.oldbet = v;
                this.playWeelSound();
            }   
        }
    }

    private isSound = false;
    playWeelSound(){
        if (!this.isSound) {
            TexasSound.playWeel()
            this.isSound = true;
            this.scheduleOnce(()=>{
                this.isSound = false;
            },0.15);
        }
    }

    //更新mask
    updateMaskSize(progress:number){
        let percent =  444*progress;
        this.maskRect.setContentSize(110,percent);
    }

    allInState(pot:number,data:JdTableData.Setting){
        let v = this.allInNode.active;
        this.allInUI = !v;
        if (!v) {
            TexasSound.winOpen();
            this.isSound = false;
            this.updateMyAllInPanel(pot,data);
        }else{
            TexasSound.winClose()
        }
    }

    set allInUI(v:boolean){
        this.allInNode.active = v;
    }

    clickMask(){
        this.allInNode.active = false;
    }

    updateRoundNo(str:string){
        this.roundNumb.string = str;
    }


    private updateMyAllInPanel(pot:number,data:JdTableData.Setting){
        pot = pot || 0;
        let betTab:{[key:number]:number} = {0:0.5,1:1,2:2};
        for (let i = 0; i < 3; i++) {
            let bt = this.allBetBtn[i];
            if (bt) {
                let btn = bt.getComponent(cc.Button);
                let lab = bt.getChildByName('numb');
                let numb = (pot*betTab[i])
                let isGray = data.chips < numb || (data.min > numb) || numb < data.min+data.params;
                btn.interactable = !isGray;
                btn.enableAutoGrayEffect = isGray;
                let str = GameUtil.currencyFormatting(numb,2);
                str = str.replace('.','a');
                JdHelp.setNodeString(lab,str);
            }
        }
    }

    showEffect(index:number,isShow:boolean = true){
        let autoBtn = this.autoBtn[index];
        if (autoBtn) {
            this.clickEff.active = isShow;
            this.clickEff.parent = autoBtn;
            this.clickEff.position = cc.v3(-95.073,17.206);
        }else{
            this.clickEff.active = false;
        }
    }

    //是否置灰按钮
    grayButton(isGray:boolean,node:cc.Node){
        if (!node) {
            return;
        }
        let btn = node.getComponent(cc.Button);
        btn.interactable = !isGray;
        btn.enableAutoGrayEffect = isGray;
        Utility.setNodeGray( node,isGray)
    }

    setLableInfo(isGray:boolean,mount:number){
        this.graylab.node.active = isGray;
        this.callLab.node.active = !isGray;
        let str = GameUtil.currencyFormatting(mount);
        let lab = isGray ? this.graylab:this.callLab;
        lab.string = str;
    }

    //设置我方操作状态
    setMySelfOperator(operator:JdTableData.Setting){
        this.clickEff.active = false;
        if (operator == null) {
            this.isInGame.active = false;
            this.noGame.active = false;
            this.allInUI = false;
            return 
        }

        this.isInGame.active = operator.isMyRound 
                                && operator.autoCheck == JdTableData.AutoSetting.None;//是否是我方回合,并且没用自动操作

        this.noGame.active = !operator.isMyRound;//不是我方回合

        if (operator.isMyRound) {
            if (operator.autoCheck == JdTableData.AutoSetting.None) {//没用自动选
                let check = operator.params == 0;//让
                let call = operator.params != 0 && (operator.params < operator.chips);//跟
                this.call.active = !check;
                this.checkNode.active = check;
                //1.控制字体样式的显示
                if (check) {//可以让牌
                }else if(call){
                    // let str = GameUtil.currencyFormatting(operator.params);
                    // let splicestr = str.replace('.','a');
                    // this.callLab.string = splicestr;
                }
                else{
                    // let str = GameUtil.currencyFormatting(operator.params);
                    // let splicestr = str.replace('.','a');
                    // this.callLab.string = splicestr;
                }
                let isGray = !(check || call)
                this.setLableInfo(isGray,operator.params);
                //2.控制按钮的显示
                //this.operatorNode[1].active = check || call;
                this.operatorNode[3].active = true;

                this.grayButton(isGray,this.operatorNode[1])

                if (operator.params + operator.min >= operator.chips) {//只能all-in
                    this.operatorNode[3].position = this.operatorNode[0].position;
                    if (check) {//可让
                        //this.operatorNode[3].position = this.operatorNode[0].position;
                    }
                    //this.operatorNode[1].active = check;
                    this.operatorNode[0].active = false;
                }else{
                    if (operator.min + operator.params < operator.chips) {//可加注
                        this.operatorNode[3].active = false;//无需allin
                        this.operatorNode[0].active = true;
                    }else{
                        this.operatorNode[0].active = false;
                        let isShowCheck = check || call
                        this.operatorNode[3].position = this.operatorNode[0].position;
                        if (!isShowCheck) {
                            //this.operatorNode[3].position = this.operatorNode[1].position;
                        }
                    }
                }
            }
        }else{
            let opType = operator.autoCheck;//操作类型
            let data = {2:2,3:1,1:0}//key-JdTableData.AutoSetting v-显示的值
            this.showEffect(data[opType]);
            this.grayButton(false,this.autoBtn[1])
            if (operator.mount > 0) {
                let mount = operator.mount
                let isGray = operator.mount > operator.chips
                if (isGray) {//大于我方余额时
                    mount = operator.chips;
                    //置灰
                }
                if (isGray) {
                    this.grayButton(isGray,this.autoBtn[1])
                }
                this.autoCall.active = true;
                this.autoCheckNode.active = false;
                let str = GameUtil.currencyFormatting(mount);
                this.autoCheckNumb.string = str
                this.autoCheckNumb.font = isGray ? this.fonts[1]:this.fonts[0];
            }else{
                this.autoCall.active = false;
                this.autoCheckNode.active = true;
            }
            this.allInUI = false;
        }
    }
}
